import Error404 from "../components/404/404";

export default function Error() {
  return (
    <>
      <Error404></Error404>
    </>
  );
}
